// extracted by mini-css-extract-plugin
export default {"dots":"dots_dots__V7YBl","dot":"dots_dot__Gsfd8","loadingFade":"dots_loadingFade__jmDRp"};